module.exports = __webpack_public_path__ + "img/vegetable-lettuce-190x100.f8674869.jpg";